import { supabase } from './supabase';

const BUCKET = 'attachments';

export const uploadFile = async (folder, file) => {
  const ext = file.name.split('.').pop();
  const safeName = `${crypto.randomUUID()}.${ext}`;
  const path = `${folder}/${safeName}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file);
  if (error) return null;
  return path;
};

export const getFileUrl = async (path) => {
  if (!path) return null;
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 3600);
  if (error) return null;
  return data?.signedUrl;
};

// Upload multiple files. Returns { files: [...uploaded], failed: number }.
export const uploadFiles = async (folder, fileList) => {
  const files = [];
  let failed = 0;
  for (const file of fileList) {
    const path = await uploadFile(folder, file);
    if (path) files.push({ name: file.name, size: file.size, type: file.type, path });
    else failed++;
  }
  return { files, failed };
};
